<!--
    描述：新增、编辑菜单弹框等
    时间：2020-04-22
    Created by zwh
-->
<template>
    <div class="">
        <el-form :model="objectForm" :rules="formRules" ref="objectForm" label-width="100px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="上级角色" prop="parentName" :show-message="false">
                        <el-input v-if="transObj.type=='addParent' || transObj.type=='edit'" v-model="objectForm.parentName" disabled autocomplete="off">
                             <el-button slot="append" icon="el-icon-plus" @click="addClick('selectParentMenu')"></el-button>
                        </el-input>
                        <el-input v-if="transObj.type=='addSon'" v-model="objectForm.parentName" disabled autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="角色名称" prop="roleName" :show-message="false">
                        <el-input v-model="objectForm.roleName" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="角色类型" prop="roleType" :show-message="false">
                        <el-select v-model="objectForm.roleType" placeholder="">
                            <el-option
                                v-for="item in roleTypeSelectList"
                                :key="item.id"
                                :label="item.sname"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="备注信息" prop="remark" :show-message="false">
                        <el-input type="textarea" v-model="objectForm.remark" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <!-- 新增、编辑等弹窗 -->
        <el-dialog :title="dialogObj.title" :visible.sync="dialogObj.visible" :width="dialogObj.width"
                   :close-on-click-modal="false" @closed="handleClose" append-to-body>
            <!-- 弹窗组件 -->
            <roleTree ref="menuTree" v-if="dialogObj.visible"
                @handle-select-parent-menu="handleSelectParentMenu"
            ></roleTree>
            <!-- footer 组件 -->
            <div slot="footer" class="dialog-footer text-center" v-if="dialogObj.mode !== 'view'">
                <el-button size="small" @click="dialogObj.visible = false">取 消</el-button>
                <el-button type="primary" size="small" :loading="btnLoading" @click="doSaveParentMenu">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import roleTree from './role_tree_dialog'
    import {getDictByParentValue} from '@/api/modules/dict.js'
    import {saveOrUpdate,getInfoById} from '@/api/modules/role.js'
    export default {
        components: {roleTree},
        props : {
            mode: {
                type: String,
                default: 'add'
            },
            transObj: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data() {
            return {
                roleTypeSelectList : [],
                parentClickTreeNode : '',

                btnLoading: false,
                objectForm: {
                    id : '',
                    parentId : '',
                    parentName : '',
                    roleName: '',
                    roleType : '',

                    remark : '',
                },
                formRules: {
                    roleName: [{required: true, message: '请输入...', trigger: 'blur'}],
                    roleType: [{required: true, message: '请选择...', trigger: 'change'}],
                    sortNum: [{required: true, message: '请输入...', trigger: 'blur'}],
                },

                dialogObj: {
                    title: '',
                    visible: false,
                    width: '650px',
                    mode: 'add',
                },
            }
        },
        methods: {
            //点击确定按钮事件
            doSave() {
                let that = this
                this.$refs['objectForm'].validate((valid) => {
                  if (valid) {
                    let param = this.objectForm;
                    saveOrUpdate(param).then(res => {
                        if(res.operationCode==1){
                            that.$message({message: '保存成功',type: 'success'});
                            //刷新菜单信息
                            that.$emit('handle-success')
                        }
                    });
                  } else {
                    return false;
                  }
                });
            },
            // 查看、编辑初始渲染数据
            getObjectById() {
                let that = this
                let param = { id : this.objectForm.id + '' }
                getInfoById(param).then(res => {
                    if(res.operationCode==1){
                        res.data != null && res.data != '' ? this.objectForm = res.data : ''
                    }
                });
            },

            addClick(type){
                this.dialogObj.title = '菜单信息';
                this.dialogObj.visible = true;
            },

            // 关闭弹窗事件
            handleClose() {

            },
            handleSelectParentMenu(obj){
                this.parentClickTreeNode = obj
            },
            doSaveParentMenu(){
                if(this.parentClickTreeNode=='' || typeof(this.parentClickTreeNode)=='undefined'){
                    this.$message({message: '请选择菜单信息',type: 'warning'});
                    return
                }

                if(this.objectForm.id == this.parentClickTreeNode.id){
                    this.$message({message: '不能选择自身作为父级菜单',type: 'warning'});
                    return
                }

                this.objectForm.parentId = this.parentClickTreeNode.id
                this.objectForm.parentName = this.parentClickTreeNode.roleName

                this.dialogObj.visible = false
            },
            getRoleType(){
                let that = this
                let param = {value: 1003};
                getDictByParentValue(param).then(res => {
                    if(res.operationCode==1){
                        that.roleTypeSelectList = res.data
                        if (this.mode !== 'add') {
                            this.getObjectById()
                        }
                    }
                });
            },
        },
        created() {
            this.objectForm.id = this.transObj.id
            this.objectForm.parentId = this.transObj.parentId
            this.objectForm.parentName = this.transObj.parentName

            this.getRoleType()
        },
        computed: {
            // 是否可编辑
            isDisabled() {
                return this.mode === 'view' ? true : false
            }
        }
    }
</script>

<style scoped lang="less">
    div .el-input-group__append, .el-input-group__prepend {
        background-color: #000;
        color: #909399;
        vertical-align: middle;
        display: table-cell;
        position: relative;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        padding: 0 20px;
        width: 1px;
        white-space: nowrap;
    }
</style>
